import { logger } from '@/shared/utils';
import { SUPPORTED_MIMES, SUPPORTED_FILE_EXTENSIONS } from '@/shared/constants/mediaConstants';

/**
 * Generates accept attribute string for file input based on category
 * @param {string} category - Category type: 'image', 'video', 'audio', 'document'/'file', 'imagevideo'
 * @returns {string} Comma-separated string of MIME types and extensions
 */
export const getAcceptString = category => {
   if (!category) return '';

   const type = category.toLowerCase();

   switch (type) {
      case 'image':
         return [...SUPPORTED_MIMES.IMAGE, ...SUPPORTED_FILE_EXTENSIONS.IMAGE].join(',');

      case 'video':
         return [...SUPPORTED_MIMES.VIDEO, ...SUPPORTED_FILE_EXTENSIONS.VIDEO].join(',');

      case 'audio':
         return [...SUPPORTED_MIMES.AUDIO, ...SUPPORTED_FILE_EXTENSIONS.AUDIO].join(',');

      case 'document':
      case 'file':
         return [...SUPPORTED_MIMES.DOCUMENT, ...SUPPORTED_FILE_EXTENSIONS.DOCUMENT].join(',');

      case 'imagevideo':
         return [
            ...SUPPORTED_MIMES.IMAGE,
            ...SUPPORTED_FILE_EXTENSIONS.IMAGE,
            ...SUPPORTED_MIMES.VIDEO,
            ...SUPPORTED_FILE_EXTENSIONS.VIDEO,
         ].join(',');

      default:
         logger.warn(`Unknown file category: ${category}`);
         return '';
   }
};

/**
 * Checks if a file type is a valid image
 * @param {string} type - MIME type
 * @returns {boolean}
 */
export const isImage = type => SUPPORTED_MIMES.IMAGE.includes(type);

/**
 * Checks if a file type is a valid video
 * @param {string} type - MIME type
 * @returns {boolean}
 */
export const isVideo = type => SUPPORTED_MIMES.VIDEO.includes(type);

/**
 * Checks if a file type is a valid audio
 * @param {string} type - MIME type
 * @returns {boolean}
 */
export const isAudio = type => SUPPORTED_MIMES.AUDIO.includes(type);

/**
 * Checks if a file type is a valid document
 * @param {string} type - MIME type
 * @returns {boolean}
 */
export const isDocument = type => SUPPORTED_MIMES.DOCUMENT.includes(type);
